(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewPositionsReport.controller:CrewPositionsReport
	 *
	 * @description
	 *
	 */
	angular
		.module('crewScheduleChangeReport')
			.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
		.controller('CrewScheduleChangeReportCtrl',CrewScheduleChangeReportCtrl);

	function CrewScheduleChangeReportCtrl(CommonMasterData, crewScheduleService,RemoteService,$sce,MessageService, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'CrewScheduleChangeReportCtrl';

		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewId : null,
				datePickerOption : {maxDate : new Date()}
			},
			masterList : {
        crewTypes : [],
				fromDateAfterToDate : false,
				isCrewAvailable : true,
				fromDateToDateAfterToDay : false,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl :null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
      params.crewType = params.crewType.crewTypeCode;
			searchCrewPositionsReport(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			if(flag == 'fromDate'&& !!searchParams.fromDate){
				var monthEnd = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
				if(isDateBeforeCurrentDate(monthEnd)){
					searchParams.toDate = monthEnd;
				} else {
					searchParams.toDate = moment().format("DD/MM/YYYY");
				}
			}
			setDateValidationFlags();
		};

		function setDateValidationFlags(){
			//if from date invalid
			vm.model.masterList.fromDateFormatInvalid = isDateFormatInvalid(vm.model.searchCriteria.fromDate);
			vm.model.masterList.toDateFormatInvalid = isDateFormatInvalid(vm.model.searchCriteria.toDate);
			vm.model.masterList.fromDateAfterToDate = (!vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateFormatInvalid &&
					istoDateBeforeFromDate()) ? true : false;
			vm.model.masterList.fromDateToDateAfterToDay = false;
		}

		function isDateFormatInvalid(date){
			if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
				return true;
			}
			return false;
		}


		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		function isDateBeforeCurrentDate(strDate){
			if(moment(strDate, "DD/MM/YYYY")
					.isAfter(new Date())){
				return false;
			}
			return true;

		}

		function searchCrewPositionsReport(param) {
			vm.model.initialSearchDone = true;
      vm.model.searchCriteria = param;
      vm.model.searchPanelToggle = false;
        var url = CommonLogicService.getReportUrl('crew_schedule_change_report.rptdesign',getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
		}

		//set search param map
		function getSearchParamMap(param){
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			if(!!param.crewType){
				searchParamMap["crewType"] = param.crewType;
			}
			return searchParamMap;
		}

    ( // load crew Types
      function loadCrewTypes() {
        CommonMasterData.getCrewTypeList(function(crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
        }, function() {
          console.log('Crew type retrieval error');
        });
      })();


	}
}());
